import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';
import { highCharts_Languages } from '@tech-helpers/charts/highcharts-languages';
import { CommonService } from '@tech-services/common.service';
import { InitcontributionService } from '@tech-services/initcontribution.service';
import { SessionService } from '@tech-services/session.service';
import * as Highcharts from 'highcharts';
import { interval, Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConfig } from '@tech-utils/app-config.service';

import {
  SimulationObjInterface,
  ProfileInterface,
  FinancialPlanRefdataInterface,
  RiskProfileInterface,
  profileAnalisysInterface,
} from '@techrules/portallib';
@Component({
  selector: 'tech-simulation-init-modelportfolio',
  templateUrl: './simulation-init-modelportfolio.component.html',
  styleUrls: ['./simulation-init-modelportfolio.component.scss'],
})
export class SimulationInitModelportfolioComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  private profileAnalysis: profileAnalisysInterface;
  public simulationObj: SimulationObjInterface;
  private options: any;
  private xAxis = [];
  private riskProfiles: RiskProfileInterface[];
  public profiles: ProfileInterface[];
  public series = [];
  private AssetClassDistribution: any;
  public colors = this.commonService.colorGrafic;
  public count: number = 0;
  public infoProfileId: boolean = false;
  @ViewChild('infoProfileIdTooltip', { static: false })
  infoProfileIdTooltip: MatTooltip;
  private timer3seg = timer(3000);
  public changeProfile: boolean = true;

  constructor(
    private commonService: CommonService,
    private initcontributionService: InitcontributionService,
    private sessionService: SessionService,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.changeProfile =
      localStorage.getItem('Domain') == 'Bulltick' ? false : true;
    this.initcontributionService.fpReferenceData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: FinancialPlanRefdataInterface) => {
        this.profiles =
          this.initcontributionService.fpReferenceDataSource.getValue().Profiles;
      });
    this.initcontributionService.simulationObj$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: SimulationObjInterface) => {
        this.simulationObj = res;
      });
    this.initcontributionService.profileAnalysis$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: profileAnalisysInterface) => {
        if (Object.entries(res).length !== 0) {
          this.profileAnalysis = res;
          this.AssetClassDistribution = res.AssetClassDistribution;
          this.loadDataCharts();
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private loadDataCharts() {
    let json: any = [];
    this.series = [];
    this.AssetClassDistribution.forEach((objAsset) => {
      json.push([objAsset.Name, objAsset.Weight * 100]);
      this.series.push({ name: objAsset.Name, data: objAsset.Weight });
    });
    this.loadChart(json);
  }

  private loadChart(json) {
    let lang =
      this.sessionService.language.substring(0, 2) == 'es'
        ? highCharts_Languages.lang_es_ES
        : highCharts_Languages.lang_en_GB;
    const options: Highcharts.Options = { lang };
    Highcharts.setOptions(options);

    this.options = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        style: {
          fontFamily: AppConfig.cssVars.fontBase,
        },
      },
      title: {
        text: '',
      },
      tooltip: {
        pointFormat: '{point.percentage:.2f}%</b>',
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false,
            distance: -50,
            style: {
              fontWeight: 'bold',
              color: 'white',
            },
          },
          startAngle: -90,
          endAngle: 270,
          center: ['50%', '50%'],
        },
      },
      series: [
        {
          type: 'pie',
          serie: '',
          innerSize: '50%',
          data: json,
        },
      ],
      credits: {
        //Para quitar la publi de la web del plugin
        enabled: false,
      },
      colors: this.colors,
    };

    Highcharts.chart('grafMPdescribed', this.options);
    this.commonService.isnotloading();
  }

  public profileIdChange(event) {
    this.commonService.isloading();
    this.initcontributionService.simulationObjSource.getValue().ProfileId =
      event;
    this.initcontributionService.simulationObjSource.next(
      this.initcontributionService.simulationObjSource.getValue()
    );
  }
  public viewInfoProfileId(event) {
    this.infoProfileIdTooltip.show();
    this.timer3seg.subscribe(() => {
      this.infoProfileIdTooltip.hide();
    });
  }
}
